import request from './request';

const branchService = {
  getAll: (params) => request.get('dashboard/admin/branches', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/branches/${id}`, { params }),
  create: (data) => request.post('dashboard/admin/branches', data, {}),
  update: (id, data) =>
    request.put(`dashboard/admin/branches/${id}`, data, {}),
  delete: (params) =>
    request.delete(`dashboard/admin/branches/delete`, { params }),
};

export default branchService;
